import React, { ReactNode } from 'react';
import styles from './publicationDetailMobile.module.scss';
import Slider from '../../components/SliderTwo';
import Button from '../../components/Button';
import { Markup } from 'interweave';
import { images } from '../../constants/images';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { usePublicationDetail } from '../PublicationDetail/hooks/usePublicationDetail';
import InformationLoader from '../PublicationDetail/Loader/Information/InformationLoader';
import DetailLoader from '../PublicationDetail/Loader/Detail/DetailLoader';
import { PublicationDetailProps } from '../../interfaces/components';
import { Skeleton } from '@mui/material';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

type PublicationDetailMobileProps = Pick<PublicationDetailProps, 'type' | 'publication' | 'loading' | 'children' | 'logoDealerships' | 'onLinzeCheckClick' | 'handleDealerLogoClick'>;

const PublicationDetailMobile: React.FC<PublicationDetailMobileProps> = ({
    type = "publication",
    publication,
    loading,
    children,
    handleDealerLogoClick,
    logoDealerships,
    onLinzeCheckClick,
}) => {
    const hookData = usePublicationDetail({ publication });

    const {
        addPointsInText,
        boldBetweenAsterisks,
        hasValidSuggestedPrices,
        hasValidSuggestedPricesPublication,
        getPriceCategory,
        getPriceCategoryPublication,
        getIndicatorPosition,
        getPriceDifferenceMessage,
        isBonus,
    } = publication && !loading ? hookData : {
        addPointsInText: (text: string) => text,
        boldBetweenAsterisks: (text: string) => text,
        hasValidSuggestedPrices: false,
        hasValidSuggestedPricesPublication: false,
        getPriceCategory: () => "",
        getPriceCategoryPublication: () => "",
        getIndicatorPosition: () => 0,
        getPriceDifferenceMessage: () => "",
        isBonus: false,
    };

    return (
        <div className={styles.container}>
            <div className={styles.sliderContainer}>
                <Slider
                    className={styles.slider}
                    sliderClassName={styles.sliderPreview}
                    type="thumbs"
                    options={
                        publication?.pictures && publication?.pictures.length > 0
                            ?
                            publication?.pictures.map((item: any, index: number) => (
                                <img loading="lazy" key={index} src={item?.path ?? item?.previewURL ?? item?.uri ?? item?.url} className={publication?.paused && styles.paused} alt={`${publication?.title} ${publication.version ?? ""} año ${publication.year}`} />
                            ))
                            :
                            [1].map((_: any, index: number) => (
                                <img loading="lazy" key={index} src={images.noImagePublication} alt="No image found publication linzecar" />
                            ))
                    }
                    pagination
                    loading={loading && (!Array.isArray(publication?.pictures) && !publication?.pictures?.length)}
                />
            </div>

            <div className={styles.mainContent}>
                {(loading && !publication?.id) ? (
                    <div className={`${styles.information} ${loading && styles.loader}`}>
                        <InformationLoader />
                    </div>
                ) : (
                    <div className={styles.information}>
                        {logoDealerships && logoDealerships !== undefined && logoDealerships !== null && (
                            <div className={styles.dealerLogo} onClick={handleDealerLogoClick}>
                                <img src={logoDealerships} alt="Dealer logo" />
                            </div>
                        )}
                        <p className={styles.description}>{publication?.year} | {addPointsInText(publication?.mileage)} km</p>
                        <h2 className={styles.title}>{publication?.title}</h2>
                        {publication?.version && (
                            <h3 className={styles.version}>{publication?.version}</h3>
                        )}
                        <p className={styles.price}>$ {addPointsInText(publication?.price)}</p>

                        {type !== 'salePost' && (
                            publication?.sold ? (
                                <h3 className={styles.sold}>Vendido</h3>
                            ) : (
                                <div className={styles.priceIndicatorContainer}>
                                    {hasValidSuggestedPricesPublication && (
                                        <div className={styles.priceIndicatorPublication}>
                                            <img
                                                src={
                                                    getPriceCategoryPublication() === "good"
                                                        ? images.checkVerde
                                                        : getPriceCategoryPublication() === "fair"
                                                            ? images.checkAmarillo
                                                            : images.checkRojo
                                                }
                                                alt="Indicador de precio"
                                                className={styles.priceIcon}
                                            />
                                            <span>
                                                {getPriceCategoryPublication() === "good"
                                                    ? "Buen precio"
                                                    : getPriceCategoryPublication() === "fair"
                                                        ? "Precio justo"
                                                        : "Precio elevado"}
                                            </span>
                                        </div>
                                    )}
                                    <div className={styles.comparaContainer}>
                                        <p className={styles.region}>
                                            <LocationOnOutlinedIcon className={styles.locationIcon} />
                                            {publication?.region}
                                        </p>
                                    </div>

                                    {loading ? (
                                        <ul className={styles.detail}>
                                            <DetailLoader />
                                        </ul>
                                    ) : (
                                        (publication?.detail && Array.isArray(publication?.detail)) && (
                                            <ul className={styles.detail}>
                                                <p className={styles.titleDetails}>Información provista por el vendedor</p>
                                                {publication?.detail?.map((item: any, index: number) => (
                                                    item?.key !== "bonus" && (
                                                        <li key={index}>
                                                            <img src={item?.icon} alt={item?.value} />
                                                            <Markup content={boldBetweenAsterisks(item?.value)} />
                                                        </li>
                                                    )
                                                ))}
                                            </ul>
                                        )
                                    )}

                                    <div className={styles.children}>{children}</div>
                                </div>
                            )
                        )}


                        <div className={styles.table}>
                            <div className={styles.comparaContainer}>

                                <p className={styles.title}>Características</p>

                            </div>
                            <table>
                                <tbody>
                                    {
                                        window.innerWidth <= 1024 && publication?.caracteristics ? publication?.caracteristics.map((item: any, index: number) => (
                                            <tr key={index} className={styles.item}>
                                                <td className={styles.icon}>
                                                    <img src={`${item?.icon}`} alt={item?.name} />
                                                </td>
                                                <td className={styles.name}>{item?.name}</td>
                                                <td className={styles.value}>
                                                    {
                                                        loading
                                                            ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                            : item?.value ?? "-"
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                            :
                                            publication?.caracteristics && publication?.caracteristics.map((item: any, index: number) => {
                                                if (index > 3) return null;
                                                return (
                                                    <tr key={index} className={styles.item}>
                                                        <td className={styles.icon}>
                                                            <img src={`${item?.icon}`} alt={item?.name} />
                                                        </td>
                                                        <td className={styles.name}>{item?.name}</td>
                                                        <td className={styles.value}>
                                                            {
                                                                loading
                                                                    ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                    : item?.value ?? "-"
                                                            }
                                                        </td>
                                                        <td className={styles.icon}>
                                                            <img src={`${publication?.caracteristics[index + 4]?.icon}`} alt={publication?.caracteristics[index + 4]?.name} />
                                                        </td>
                                                        <td className={styles.name}>{publication?.caracteristics[index + 4]?.name}</td>
                                                        <td className={styles.value}>
                                                            {
                                                                loading
                                                                    ? <Skeleton animation="wave" variant="text" className={styles.skeleton} />
                                                                    : publication?.caracteristics[index + 4]?.value ?? "-"
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                    }
                                </tbody>
                            </table>
                        </div>

                        {publication?.chatgpt_description && (
                            <div className={styles.vehicleDescription}>
                                <div className={styles.descriptionHeader}>
                                    <p className={styles.title}>Descripción del vehículo</p>
                                    <p className={styles.subtitle}>
                                        <AutoAwesomeIcon className={styles.svg} />
                                        <span className={styles.textIA}>Generado por Linze IA</span>
                                    </p>
                                </div>
                                <p className={styles.descriptionText}>
                                    {publication.chatgpt_description}
                                </p>
                            </div>
                        )}

                        {publication?.records?.length > 0 && type === "salePost" && (
                            <div className={styles.additionalDetails}>
                                {publication.records.map((item: any, index: number) => (
                                    <p key={index} className={styles.detailText}>
                                        <img src={`${item?.icon}`} alt={item?.name} /> {item.value}
                                    </p>
                                ))}
                            </div>
                        )}

                        {hasValidSuggestedPricesPublication && (
                            <div className={styles.marketPriceSection}>
                                <h3>Precios del mercado</h3>
                                <div className={styles.marketPriceInfo}>
                                    <div className={styles.priceBar}>
                                        <div className={styles.priceBarInner}>
                                            {/* Precio + etiqueta arriba del indicador */}
                                            <div
                                                className={styles.priceTag}
                                                style={{ left: `${getIndicatorPosition()}%` }}
                                            >
                                                <p className={styles.actualPrice}>${addPointsInText(publication?.price)}</p>
                                                <div className={styles.priceCategory}>
                                                    <img
                                                        src={
                                                            getPriceCategory() === "good"
                                                                ? images.checkVerde // buena imagen
                                                                : getPriceCategory() === "fair"
                                                                    ? images.checkAmarillo // imagen regular
                                                                    : images.checkRojo // imagen cara
                                                        }
                                                        alt="Indicador de precio"
                                                        className={styles.priceIcon}
                                                        style={{ width: '18px', height: '18px' }}
                                                    />
                                                    {getPriceCategory() === "good"
                                                        ? "Buen precio"
                                                        : getPriceCategory() === "fair"
                                                            ? "Precio justo"
                                                            : "Precio elevado"}
                                                </div>
                                            </div>

                                            {/* Línea + marcador */}
                                            <div className={styles.pricePointer} style={{ left: `${getIndicatorPosition()}%` }} />
                                        </div>
                                    </div>
                                    <div className={styles.suggestedPriceDisplay}>
                                        <h3>${publication?.suggested_prices?.suggested_price}</h3>
                                        <p>Precio Sugerido</p>
                                    </div>

                                    <p className={styles.priceInfo}>
                                        {getPriceDifferenceMessage()}
                                    </p>
                                </div>
                            </div>
                        )}

                        {type === "salePost" && (
                            <div className={styles.buttonRow}>
                                <div className={styles.priceIndicatorWrapper}>
                                    {hasValidSuggestedPrices && (
                                        <div className={styles.priceIndicator}>
                                            <img
                                                src={
                                                    getPriceCategory() === "good"
                                                        ? images.checkVerde
                                                        : getPriceCategory() === "fair"
                                                            ? images.checkAmarillo
                                                            : images.checkRojo
                                                }
                                                alt="Indicador de precio"
                                                className={styles.priceIcon}
                                            />
                                            {getPriceCategory() === "good"
                                                ? "Buen precio"
                                                : getPriceCategory() === "fair"
                                                    ? "Precio justo"
                                                    : "Precio elevado"}
                                        </div>
                                    )}
                                </div>
                                <div className={styles.buttons}>
                                    <Button
                                        title="Negociar"
                                        onPress={() => console.log('Negociar')}
                                        tertiary
                                        disabled
                                        size='small'
                                        className={styles.button}
                                    />
                                    <Button
                                        title="Comprar"
                                        onPress={() => console.log('Comprar')}
                                        primary
                                        disabled
                                        size='small'
                                        className={styles.button}
                                    />
                                </div>
                            </div>
                        )}
                        {type !== "salePost" &&
                            <div className={styles.imageSection} onClick={onLinzeCheckClick}>
                                <img
                                    src={images.autoIcar}
                                    alt="Descripción de la imagen"
                                    className={styles.promoImage}
                                />
                                <div className={styles.overlay}>
                                    <p className={styles.overlayTitle}>icar</p>
                                    <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                                    <Button
                                        title="Solicitar Informe"
                                        onPress={onLinzeCheckClick}
                                        tertiary
                                        size='small'
                                        className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                                    />
                                </div>
                            </div>
                        }
                        {type === "salePost" &&
                            <div
                                className={`${styles.imageSection} ${styles.disabled}`}
                                onClick={(e) => e.preventDefault()}
                            >
                                <img
                                    src={images.autoIcar}
                                    alt="Descripción de la imagen"
                                    className={styles.promoImage}
                                />
                                <div className={styles.overlay}>
                                    <p className={styles.overlayTitle}>icar</p>
                                    <p className={styles.overlayText}>Adquiere el informe técnico del vehículo</p>
                                    <Button
                                        title="Solicitar Informe"
                                        onPress={onLinzeCheckClick}
                                        tertiary
                                        size='small'
                                        disabled
                                        className={`${styles.btnInformeOverlay} ${styles.customButtonOverlay}`}
                                    />
                                </div>
                            </div>
                        }


                        {type === "salePost" &&
                            <div className={styles.salePostButtons}>
                                {children}
                            </div>
                        }
                        {!loading && (publication?.certified || isBonus) && (
                            <div className={styles.certifiedFinancing}>
                                {publication?.certified && (
                                    <div className={`${styles.item} ${styles.certified}`}>
                                        <p>Vehículo verificado</p>
                                        <img src={images.check_blue} alt="vehículo verificado" />
                                    </div>
                                )}
                                {isBonus && (
                                    <div className={`${styles.item} ${styles.financingBonus}`}>
                                        <img src={images.financingBonus} alt="bono con financiamiento" />
                                        <p>Bono con financiamiento</p>
                                    </div>
                                )}
                            </div>
                        )}


                    </div>
                )}
            </div>
        </div>
    );
};

export default PublicationDetailMobile;
